import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { CommunityStats } from "@/components/CommunityStats";
import { PlatformsMarquee } from "@/components/PlatformsMarquee";
import { PlatformsCatalog } from "@/components/PlatformsCatalog";
import { GlobalReachMap } from "@/components/GlobalReachMap";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { RoyaltyCard } from "@/components/RoyaltyCard";
import { ComparisonTable } from "@/components/ComparisonTable";
import { Testimonials } from "@/components/Testimonials";
import { ParaQuien } from "@/components/ParaQuien";
import { Security } from "@/components/Security";
import { FAQSection } from "@/components/FAQSection";
import { Footer } from "@/components/Footer";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <CommunityStats />
      <PlatformsMarquee />
      <PlatformsCatalog />
      <GlobalReachMap />
      <Services />
      <Process />
      <RoyaltyCard />
      {/* Plans temporalmente oculta a pedido del usuario mientras confirma precios finales */}
      {/* ComparisonTable temporalmente oculta a pedido del usuario mientras confirma datos */}
      <Testimonials />
      <ParaQuien />
      <Security />
      <FAQSection />
    </main>
    <Footer />
  </>
);

export default Home;
